"use client";
import {
  Link,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Activity } from "../../models/Activity";
import { ClientRoutes } from "../../models/ClientRoutes";
import { ActivityToolInformation } from "../../models/Tool";
import { getProcessPathsOfActivity } from "../../services/ActivityService";
import { SkanskaColorTokens } from "../../style/colors";

const useStyles = makeStyles({
  activitiesTable: {
    width: "fit-content",
    tableLayout: "auto",
  },
  toolLinks: {
    textDecoration: "none",
    color: SkanskaColorTokens.color_primary_blue,
    fontFamily: "Shape Sans Light !important",
    whiteSpace: "nowrap",
    "&:hover": {
      textDecoration: "underline",
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: "4px",
    marginTop: "4px",
  },
  titleColumn: {
    textAlign: "left",
    whiteSpace: "nowrap",
    width: "auto",
    minWidth: "auto",
  },
  publishedByColumn: {
    textAlign: "left",
    whiteSpace: "nowrap",
    width: "auto",
    minWidth: "auto",
  },
  publishedDateColumn: {
    textAlign: "left",
    whiteSpace: "nowrap",
    width: "auto",
    minWidth: "auto",
  },
});

export interface ActivitiesUsingToolTableProps {
  activities: ActivityToolInformation[];
}

export const ActivitiesUsingToolTable = (
  props: ActivitiesUsingToolTableProps
) => {
  const { activities } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Table
      aria-label={t("activitiesUsingThisTool")}
      className={classes.activitiesTable}
    >
      <TableHeader>
        <TableRow>
          <TableHeaderCell className={classes.titleColumn}>
            {t("activitiesUsingToolTable.processPathHeading")}
          </TableHeaderCell>
          <TableHeaderCell className={classes.publishedByColumn}>
            {t("publishedBy")}
          </TableHeaderCell>
          <TableHeaderCell className={classes.publishedDateColumn}>
            {t("publishedDate")}
          </TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {activities.map((activity) => (
          <TableRow key={activity.versionId}>
            <TableCell className={classes.titleColumn}>
              {getProcessPathsOfActivity(activity as Activity).length > 0 ? (
                getProcessPathsOfActivity(activity as Activity).map(
                  (path, i) => (
                    <Link
                      key={i}
                      className={classes.toolLinks}
                      onClick={() =>
                        navigate(
                          `${ClientRoutes.ActivitiesPublished}/${activity.versionId}`
                        )
                      }
                    >
                      {path}
                    </Link>
                  )
                )
              ) : (
                <Link
                  className={classes.toolLinks}
                  onClick={() =>
                    navigate(
                      `${ClientRoutes.ActivitiesPublished}/${activity.versionId}`
                    )
                  }
                >
                  {activity.title}{" "}
                  {t("activitiesUsingToolTable.missingProcessPath")}
                </Link>
              )}
            </TableCell>
            <TableCell className={classes.publishedByColumn}>
              {activity.publishedBy?.displayName ?? "-"}
            </TableCell>
            <TableCell className={classes.publishedDateColumn}>
              {activity.publishedTimeInUTC
                ? new Date(activity.publishedTimeInUTC).toLocaleString([], {
                    hour12: false,
                  })
                : "-"}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
export default ActivitiesUsingToolTable;
